import React, { useEffect, useState } from 'react';
import "../Styles/MDLandingPage.css";
import { useNavigate, useParams } from 'react-router-dom';
import Img from "../Assets/icons/VELOXLogo.png";
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../Components/LanguageSelector';

const VALIDATE_MD = true; 

const MDLandingPage = () => {
  const navigate = useNavigate();
  const { mdId } = useParams();
  const [webVersion, setWebVersion] = useState("");
  const [mdValid, setMdValid] = useState(null); 
  const [loadingMd, setLoadingMd] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/version.json`)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.webVersion) setWebVersion(data.webVersion);
      })
      .catch(() => {
      });
  }, []);

  useEffect(() => {
    if (!VALIDATE_MD || !mdId) {
      setMdValid(null);
      return;
    }
    let ignore = false;
    let redirectTimer = null;

    const check = async () => {
        try {
            setLoadingMd(true);
            const res = await fetch(`/api/validate_md/${encodeURIComponent(mdId)}`);
            if (ignore) return;
            if (res.ok) {
                setMdValid(true);
            } else if (res.status === 404) {
                setMdValid(false);
                toast.error("Your URL is not valid. Redirecting to home...");
                redirectTimer = setTimeout(() => {
                    navigate("/", { replace: true });
                }, 3000);
            } else {
          setMdValid(null);
        }
      } catch (e) {
        if (!ignore) setMdValid(null);
      } finally {
        if (!ignore) setLoadingMd(false);
      }
    };
    check();
    return () => { ignore = true;
        if (redirectTimer) clearTimeout(redirectTimer);
     };
  }, [mdId]);

  const withMdQuery = (path) => {
    if (!mdId) return path;
    const sep = path.includes("?") ? "&" : "?";
    return `${path}${sep}md=${encodeURIComponent(mdId)}`;
  };

  const handleLoginClick = () => {
    navigate(`/${mdId}/login`);
  };

  return (
    <div>
      <div className='logo-VELOX'>
        <img
          src={Img}
          alt="VELOX Life Safety Inc."
          className="logo"
          data-version={webVersion}
        />

        <button className='login-botton' onClick={handleLoginClick}>
          {t('login')}
        </button>

        <LanguageSelector />
      </div>

      <hr className='login-breakline' />

      {mdId && (
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <div style={{ fontSize: 14, opacity: 0.8 }}>
            Master Distributor ID: <strong>{mdId}</strong>
            {VALIDATE_MD && (
              <span style={{ marginLeft: 8 }}>
                {loadingMd && ' (validating...)'}
                {mdValid === true && ' (valid)'}
                {mdValid === false && ' (invalid)'}
              </span>
            )}
          </div>
        </div>
      )}

      <p className="web-version">
        Version {webVersion}
      </p>

      <ToastContainer />
    </div>
  );
};

export default MDLandingPage;
